// @flow
import type { Node } from 'react';
import Enum from '@rover/react-lib/types/Enum';

export class ButtonType extends Enum<string> {
  static DEFAULT = new ButtonType('default');

  static PRIMARY = new ButtonType('primary');

  static PRIMARY_NEXT = new ButtonType('primary_next');

  static DARK = new ButtonType('dark');

  static DARK_TRANSPARENT = new ButtonType('dark-transparent');

  static TEXT = new ButtonType('text');

  static TEXT_LIGHT = new ButtonType('text-light');

  static DANGER = new ButtonType('danger');

  static TERTIARY = new ButtonType('tertiary');

  static isLocked = true;
}

export type Props = {|
  buttonType: ButtonType,
  children?: Node,
  onClick?: (*) => any,
  disabled?: boolean,
|};

export type ButtonAppearance = {|
  buttonType: $PropertyType<Props, 'buttonType'>,
  disabled?: boolean,
|};



// WEBPACK FOOTER //
// ../react-lib/src/components/buttons/Button/Button.types.js